import { SessionStorage } from '@execonline-inc/browser-storage.private';
import { warn } from '@execonline-inc/logging';
import { always, noop } from '@kofno/piper';
import type { Maybe } from 'maybeasy';
import { Task } from 'taskarian';

const storageKey = 'preAuthenticationDestination' as const;

export const savePreAuthenticationDestination = (): void => {
  SessionStorage.setItem(storageKey, window.location.href).fork(
    (e) => warn(`Failed to save pre-authentication destination: ${e.error}`),
    noop,
  );
};

const readPreAuthenticationDestination = () =>
  SessionStorage.getItem(storageKey).elseDo((e) =>
    warn('Failed to read pre-authentication destination from session storage.', e),
  );

const removePreAuthenticationDestination = <T>(passthrough: T) =>
  SessionStorage.removeItem(storageKey)
    .elseDo((e) => warn('Failed to remove pre-authentication destination from session storage.', e))
    .map(always(passthrough));

const whenLocationPresent = (l: Maybe<string>) =>
  l.cata<Task<unknown, string>>({ Nothing: () => Task.fail({}), Just: Task.succeed });

export const popPreAuthenticationDestination = () =>
  Task.succeed<unknown, {}>({})
    .andThen(readPreAuthenticationDestination)
    .andThen(removePreAuthenticationDestination)
    .andThen(whenLocationPresent);
